module.exports = __webpack_public_path__ + "static/media/portfolio1.d3cbdfae.jpg";